import * as $ from 'jquery';

const MOBILE_WIDTH = 768;

$(function () {
  function sliderMain() {
    let currentIndex = 0;
    const $services = $('.service-slider__wrapper');
    const maxVisibleCards = 3;
    const $prevButton = $('.service-slider__btn_prev');
    const $nextButton = $('.service-slider__btn_next');

    function updateSlider() {
      const $servicesCards = $('.services-slider__cards');
      const gap = parseInt($servicesCards.css('gap')) || 0;
      const cardWidth = $services[0].getBoundingClientRect().width + gap;

      $servicesCards.css('transform', `translateX(${-currentIndex * cardWidth}px)`);

      if (currentIndex === 0) {
        $prevButton.addClass('service-slider__btn_hidden');
      } else {
        $prevButton.removeClass('service-slider__btn_hidden');
      }

      if (currentIndex >= $services.length - maxVisibleCards) {
        $nextButton.addClass('service-slider__btn_hidden');
      } else {
        $nextButton.removeClass('service-slider__btn_hidden');
      }
    }

    function prevSlide() {
      if (currentIndex > 0) {
        currentIndex--;
        updateSlider();
      }
    }

    function nextSlide() {
      if (currentIndex < $services.length - maxVisibleCards) {
        currentIndex++;
        updateSlider();
      }
    }

    updateSlider();

    $prevButton.on('click', prevSlide);
    $nextButton.on('click', nextSlide);
  }

  function sliderMainMobile() {
    const $nextButton = $('.service-slider-mobile__btn_next');
    const $prevButton = $('.service-slider-mobile__btn_prev');
    const $servicesScroll = $('.services__wrapper');
    const cardWidth = $('.service__wrapper').outerWidth(true) + 16;

    function updateSliderButtons() {
      const scrollLeft = $servicesScroll.scrollLeft();
      const scrollWidth = $servicesScroll[0]?.scrollWidth;
      const clientWidth = $servicesScroll[0]?.clientWidth;

      if (scrollLeft === 0) {
        $prevButton.addClass('service-slider-mobile__btn_hidden');
      } else {
        $prevButton.removeClass('service-slider-mobile__btn_hidden');
      }
      if (scrollLeft + clientWidth >= scrollWidth) {
        $nextButton.addClass('service-slider-mobile__btn_hidden');
      } else {
        $nextButton.removeClass('service-slider-mobile__btn_hidden');
      }
    }

    function prevSlide() {
      $servicesScroll[0].scrollBy({
        left: -cardWidth,
        behavior: 'smooth',
      });
      setTimeout(updateSliderButtons, 300);
    }

    function nextSlide() {
      $servicesScroll[0].scrollBy({
        left: cardWidth,
        behavior: 'smooth',
      });
      setTimeout(updateSliderButtons, 300);
    }

    updateSliderButtons();

    $prevButton.click(prevSlide);
    $nextButton.click(nextSlide);

    $servicesScroll.on('scroll', updateSliderButtons);
  }

  if ($(window).width() > MOBILE_WIDTH) {
    sliderMain();
  } else {
    sliderMainMobile();
  }
});
